// extracted by mini-css-extract-plugin
module.exports = {"cover":"Section_cover__11NcP","wrap":"Section_wrap__3ay8S"};